import { Component, Input } from '@angular/core';
import { BundleLoaderService } from 'src/app/services/bundle-loader/bundle-loader.service';
import { Subject } from 'rxjs';
import { Train } from 'src/app/models/train-info.model';
import { environment } from 'src/environments/environment';
import { IOHDynamicDialogService } from '../service/ioh-dialog.service';

@Component({
  selector: 'csx-ioh-train-callout',
  templateUrl: './ioh-train-callout.component.html',
  styleUrl: './ioh-train-callout.component.scss'
})
export class IOHTrainCalloutComponent {
  @Input() isWarRoom = false;
  train: Train | undefined;
  private destroySource = new Subject<void>();
  constructor(
    private dynamicDialogService: IOHDynamicDialogService,
    private _bundleLoaderService: BundleLoaderService
  ) {}

  ngOnInit() {
    this.train = this.dynamicDialogService.getSelectedTrain();
    this.loadComponentBundle();
  }

  //to load realtime-train-details web component bundle
  loadComponentBundle() {
    if (environment?.appConfig?.webComponents?.realtimeTrainDetails) {
      if (!customElements.get('csxwc-realtime-train-details')) {
        environment.appConfig.webComponents.realtimeTrainDetails.forEach(
          url => {
            this._bundleLoaderService.loadBundle(url);
          }
        );
      }
    }
  }

  //to close imod-operations-info web component
  close() {
    this.dynamicDialogService.closeTrainCallout();
  }

  ngOnDestroy(): void {
    this.destroySource.next();
  }
}
